<template>
	<div class="flex flex-row space-x-4 w-full justify-between text-vc-small">
		<div
			class="w-8 h-8 rounded-full flex items-center justify-center bg-accent-red hover:cursor-pointer"
			role="button"
			aria-label="decrease"
			@click="decrease"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				stroke-width="1.5"
				stroke="white"
				class="size-6"
			>
				<path
					stroke-linecap="round"
					stroke-linejoin="round"
					d="M5 12h14"
				/>
			</svg>
		</div>

		<div
			class="w-8 h-8 rounded-full flex items-center justify-center bg-accent-red text-white font-medium"
		>
			{{ quantity }}
		</div>

		<div
			class="w-8 h-8 rounded-full flex items-center justify-center bg-accent-red hover:cursor-pointer"
			role="button"
			aria-label="increase"
			:class="{ 'opacity-50': quantity >= maxQuantity }"
			@click="increase"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				stroke-width="1.5"
				stroke="white"
				class="size-6"
			>
				<path
					stroke-linecap="round"
					stroke-linejoin="round"
					d="M12 4.5v15m7.5-7.5h-15"
				/>
			</svg>
		</div>
	</div>
</template>

<script>
export default {
	name: 'QuantitySelector',
	props: {
		quantity: {
			type: Number,
			required: true
		},
		maxQuantity: {
			type: Number,
			required: true,
			default: Infinity
		}
	},
	emits: ['decrease', 'increase'],
	setup(props, { emit }) {
		const decrease = () => {
			emit('decrease')
		}

		const increase = () => {
			if (props.quantity < props.maxQuantity) {
				emit('increase')
			}
		}

		return {
			decrease,
			increase
		}
	}
}
</script>
